import React from 'react';
import { Button } from 'antd';
import { crmClienteUrl, crmFarmaciaUrl } from '../../api/vinculacionApi';

export const nf = new Intl.NumberFormat('es-ES');

/** Enlace a la ficha de cliente (farmacéutico) en el CRM Gescom-AQ. */
export const CrmCliente: React.FC<{ id?: number; children: React.ReactNode }> = ({ id, children }) =>
  id ? (
    <a href={crmClienteUrl(id)} target="_blank" rel="noreferrer" title="Abrir ficha en CRM">
      {children}
    </a>
  ) : (
    <>{children}</>
  );

/** Enlace a la ficha de farmacia (entidad) en el CRM Gescom-AQ. */
export const CrmFarmacia: React.FC<{ id?: number; children: React.ReactNode }> = ({ id, children }) =>
  id ? (
    <a href={crmFarmaciaUrl(id)} target="_blank" rel="noreferrer" title="Abrir ficha de farmacia en CRM">
      {children}
    </a>
  ) : (
    <>{children}</>
  );

/** Descarga un CSV (separador ';', BOM para Excel). */
export const exportCsv = (filename: string, headers: string[], rows: (string | number)[][]) => {
  const esc = (v: string | number) => `"${String(v ?? '').replace(/"/g, '""')}"`;
  const lines = [headers.map(esc).join(';'), ...rows.map((r) => r.map(esc).join(';'))];
  const blob = new Blob(['﻿' + lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
};

/** Botón-filtro con estado activo (estilo GCvsc). */
export const FilterBtn: React.FC<{ active: boolean; onClick: () => void; children: React.ReactNode }> = ({
  active,
  onClick,
  children,
}) => (
  <Button size="small" type={active ? 'primary' : 'default'} onClick={onClick}>
    {children}
  </Button>
);

export const cmpNum = (a?: number, b?: number) => (a ?? 0) - (b ?? 0);
export const cmpTxt = (a?: string, b?: string) => (a ?? '').localeCompare(b ?? '');
